import PropTypes from 'prop-types'
import NoneAnchor from 'components/NoneAnchor'
import { isPresent } from 'utils'
import { ReviewStatus } from 'features/Codes'
import { useDispatch } from 'react-redux'
import { hideBackDrop, showBackDrop } from 'features/dialog/backDropSlice'
import api from 'api/axios/foka'
import { showKeywordLandingUrlEdit } from 'features/dashboard/operation/keywordLandingUrlEdit/keywordLandingUrlEditModalSlice'
import { useAlert } from 'features/dialog/Alert'
import { noop } from 'lodash'

const LandingUrlEditLink = ({
  id,
  text,
  landingUrl,
  landingUrlReviewStatus,
  bizChannelId,
  className = 'fc_emph',
  disabled = false,
  children,
}) => {
  const dispatch = useDispatch()
  const [ApprovingAlert, showApprovingAlert] = useAlert()
  const handleClick = async () => {
    if (!disabled) {
      if (isPresent(landingUrl) && landingUrlReviewStatus === 'APPROVING') {
        showApprovingAlert()
      } else {
        dispatch(showBackDrop())
        await api.ad
          .getBizChannel(bizChannelId)
          .then(
            ({
              data: {
                siteUrl: { pcSiteYn, mobileSiteYn, individualSettingYn },
              },
            }) => {
              const siteSetting = {
                hasPcSite: pcSiteYn === 'Y',
                hasMobileSite: mobileSiteYn === 'Y',
                isIndividual: individualSettingYn === 'Y',
              }
              dispatch(
                showKeywordLandingUrlEdit({
                  keywords: [
                    {
                      id,
                      text,
                      landingUrl,
                    },
                  ],
                  siteSetting,
                })
              )
            }
          )
          .catch(noop)
        dispatch(hideBackDrop())
      }
    }
  }
  return disabled ? (
    <>{children}</>
  ) : (
    <>
      <NoneAnchor className={className} onClick={handleClick}>
        {children}
      </NoneAnchor>
      <ApprovingAlert title="랜딩URL변경">
        선택된 키워드의 랜딩URL이 현재 {ReviewStatus.APPROVING.title}으로 변경이
        불가능합니다.
      </ApprovingAlert>
    </>
  )
}
LandingUrlEditLink.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  landingUrl: PropTypes.shape({
    individualSettingYn: PropTypes.oneOf(['Y', 'N']),
    pcLandingUrl: PropTypes.shape({
      protocol: PropTypes.string,
      url: PropTypes.string,
    }),
    mobileLandingUrl: PropTypes.shape({
      protocol: PropTypes.string,
      url: PropTypes.string,
    }),
  }),
  landingUrlReviewStatus: PropTypes.string.isRequired,
  bizChannelId: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node,
}
export default LandingUrlEditLink
